import { Navigate } from "react-router-dom";

function AdminProtectedRoute({ children }) {
  const token = localStorage.getItem("SLNAdminToken");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdminProtectedRoute;
